<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "PointsLog",
  components: {CommonTable},
  data() {
    return {  rechargeVisible: false,
      rechargeForm: {
        agentId: '',
        username: '',
        amount: '',
        expound: '',
        actionName:''
      },
      domainTitle: '',
      domainVisible: false,
      domainForm: {
        agentId: '',
        domain: '',
        actionName:'',
      },
      domains: [],
      domainIds: [],
      agent: {},

      resetPwdVisible: false,
      resetPwdForm: {
        id: '',
        username: '',
        password: '',
        googleCode: ''
      },

      topAgents: null,
      agentParentForm: {
        id: '',
        parentId: '',
        username: '',
      },
      agentParentVisible: false,
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'actionId',
        placeholder: '动作',
        type: 'select',
        selectUrl: '/pointsConfig/getAll',
        selectData: [],
      }],
      permission: {
        add: 'pointsLog:add',
        update: 'pointsLog:update',
        delete: 'pointsLog:delete',
        deleteBatch: 'pointsLog:deleteBatch'
      },
      url: {
        get: '/pointsLog/listByCondition',
        add: '/pointsLog/add',
        update: '/pointsLog/update',
        delete: '/pointsLog/delete/',
        delete_batch: '/pointsLog/deleteBatch',
        status: '/pointsLog/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },{
        field: 'actionName',
        label: '用户动作',
        show: true,
        width: '',
      }, {
        field: 'startPoints',
        label: '开始积分',
        show: true,
        width: '',
      },{
        field: 'pointsChange',
        label: '积分变化',
        show: true,
        width: '',
      },{
        field: 'endPoints',
        label: '最终积分',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '积分记录表',
        updateTitle: '积分记录表',
        model: [{
          field: 'actionId',
          label: '动作Id',
          type: 'input',
          placeholder: '动作Id',
          rules: [{message: '请输入动作Id', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'points',
          label: '积分',
          type: 'input',
          placeholder: '积分',
          rules: [{message: '请输入积分', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
